<template>
  <div id="footer" class="container-fluid">
    <div class="flex" style="padding-top: 20px;justify-content: space-between">
      <div class="logo" style="min-width: 320px;">
        <img src="@/assets/img/logo.png" alt="logo图">
        <p>kjlmxm@yeah.net</p>
        <p style="margin-top: 20px;">福建省厦门市湖里区海西金融广场9F </p>
        <p>福建省福州市台江区鳌兴时代5F</p>
        <img class="weibo" style="right: 115px;" src="../assets/img/weibo.png" alt="" srcset="">
        <img class="weixin" style="right: 65px;" src="../assets/img/weixin.png" alt="" srcset="">
      </div>
      <div class="flex" style="flex-wrap: wrap;position: relative;">

        <p>关于跨境联盟</p>
        <p>跨境电商解决方案</p>
        <p> 跨境电商小程序</p>


        <p>跨境中央仓系统</p>
        <p>跨境合作加盟</p>
        <p> 跨境电商配套服务</p>



        <p>跨境电商OEM</p>
        <p>跨境新媒体运营</p>
        <p> 活力联盟</p>
        <img class="qrcode" style="right: 0px;" src="../assets/img/qrcode.jpg" alt="" srcset="">
      </div>
    </div>
    <div style="margin-top: 70px;border-top: 1px solid #3373A7;padding-top: 30px;">
      <p class="copy">
        跨境联盟（厦门）信息科技有限公司 版权所有 闽ICP备2021014802号-3
      </p>
      <p class="copy">
        Copyright &copy; 2016 - {{ new Date().getFullYear() }} All rights reserved</p>
    </div>

  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped stylus="less">
#footer {
  width: 100%;
  box-sizing: border-box;
  margin: auto;
  height: 100%;
  color: #fff;
  background: #004984;
  overflow: hidden;
  text-align: center;
  padding: 40px 200px;
  position: relative;


}

.flex {
  display: flex;
  align-items: flex-start;

}
.flex p {
  width: 33%;
  font-size: 16px;
  text-align: right;
  margin: 10px 0;
}
.logo {
  position: relative;




}

.logo img {
  width: 200px;

  margin-bottom: 40px;


}

.logo p {
  width: 100% !important;
  margin-top: 10px;
  text-align: left !important;
}

.weibo,
.weixin {
  position: absolute;
  width: 30px !important;
  height: 30px;
  top: 98px;

}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: white;
  font-size: 14px;
  margin: 10px 0 10px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }

}

@media screen and (max-width: 1250px) {
  #footer {
    width: 100%;
    padding: 40px 20px;
  }
}

.qrcode {
  width: 132px;
  height: 132px;
  position: absolute;
  right: 0;
  bottom: -140px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue